export default {"src":"/_next/static/media/avax.afddd00c.svg","height":30,"width":102,"blurWidth":0,"blurHeight":0};